import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconRadiusTopRight24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconRadiusTopRight24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M19.755 17v-3.303a9.25 9.25 0 0 0-9.25-9.25H7a.75.75 0 1 1 0-1.5h3.505c5.937 0 10.75 4.813 10.75 10.75V17a.75.75 0 1 1-1.5 0M13 20a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3.372 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2M9 20a1 1 0 1 1-2 0 1 1 0 0 1 2 0M4 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2m1 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0m0 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconRadiusTopRight24);
